import React from 'react';

import {
  CheckInCardTestPeriodFragment,
  DashboardMostRecentLabSubmissionFragment,
  LabSubmissionStatusEnum,
  Maybe,
  MostRecentLabSubmissionWithResultsFragment,
} from '#apollo/schema';
import {useViewportSize} from '#hook';

import {
  AccountCardNarrow,
  MyTallyAgeCard,
  PurchaseATestCard,
  RegisterTestCard,
  SetTracker,
  UnderstandResultsCard,
  UnlockActionPlans,
  UpgradeToMembershipCardWide,
  UpgradeToMembershipNarrow,
} from './common';
import {processDashboardData} from './Dashboard.util';

export type DefaultDashboardProps = {
  hasSubscription: boolean;
  testKitCheckOutLink: string;
  mostRecentLabSubmission: Maybe<DashboardMostRecentLabSubmissionFragment> | undefined;
  labSubmissions: Maybe<{id: string}[]> | undefined;
  currentTestPeriod: Maybe<CheckInCardTestPeriodFragment> | undefined;
  mostRecentLabSubmissionWithResults: Maybe<MostRecentLabSubmissionWithResultsFragment> | undefined;
};

export const DefaultDashboard = ({
  hasSubscription,
  testKitCheckOutLink,
  mostRecentLabSubmission,
  labSubmissions,
  currentTestPeriod,
  mostRecentLabSubmissionWithResults,
}: DefaultDashboardProps) => {
  const {isDesktop} = useViewportSize();
  const {labAssessment, registeredDate, mostRecentStatus, hasLabSubmissions, hasPriorResults} =
    processDashboardData({
      mostRecentLabSubmission,
      labSubmissions,
      currentTestPeriod,
      mostRecentLabSubmissionWithResults,
    });

  if (mostRecentStatus && mostRecentStatus === LabSubmissionStatusEnum.Ready) {
    return (
      <>
        <MyTallyAgeCard labAssessment={labAssessment} registeredDate={registeredDate} />
        <UnderstandResultsCard hasLabAssessment={true} />
        {isDesktop ? <UpgradeToMembershipCardWide /> : <UpgradeToMembershipNarrow />}
        <UnlockActionPlans columnSpan={[8, 8, 4]} />
        <AccountCardNarrow />
        <UnderstandResultsCard hasLabAssessment={false} />
      </>
    );
  }

  if (mostRecentStatus && hasLabSubmissions && hasPriorResults) {
    return (
      <>
        <SetTracker
          labSubmissions={labSubmissions || []}
          mostRecentLabSubmission={mostRecentLabSubmission}
        />
        {isDesktop ? <UpgradeToMembershipCardWide /> : <UpgradeToMembershipNarrow />}
        <UnlockActionPlans columnSpan={[8, 8, 4]} />
        <AccountCardNarrow />
        <UnderstandResultsCard hasLabAssessment={false} />
      </>
    );
  }
  if (mostRecentStatus && hasLabSubmissions) {
    return (
      <>
        <SetTracker
          labSubmissions={labSubmissions || []}
          mostRecentLabSubmission={mostRecentLabSubmission}
        />
        <UnderstandResultsCard hasLabAssessment={false} />
        <AccountCardNarrow />
      </>
    );
  }

  return (
    <>
      <AccountCardNarrow />
      {hasSubscription ? <PurchaseATestCard href={testKitCheckOutLink} /> : <RegisterTestCard />}
    </>
  );
};
